import { AdPlacement } from "@/components/ads/AdPlacement";
import {
  SciBreadcrumb,
  SciExplainer,
  SciHeader,
  SciPage,
} from "@/lib/science/sci-ui";
import { m } from "@/paraglide/messages";
import { WaterIntakeCalc } from "../components/WaterIntakeCalc";

export function CalculatorPage() {
  return (
    <SciPage>
      <SciBreadcrumb
        homeLabel={m.sci_breadcrumb_home()}
        toolName={m.water_tool_name()}
        toolPath="/water-intake-calculator"
      />
      <SciHeader title={m.water_h1()} intro={m.water_intro()} />
      <WaterIntakeCalc />
      <SciExplainer
        howToTitle={m.sci_howto_title()}
        howTo={m.water_howto()}
        examplesTitle={m.sci_examples_title()}
        examples={[m.water_ex1(), m.water_ex2(), m.water_ex3()]}
        faqTitle={m.sci_faq_title()}
        faqs={[
          { q: m.water_faq_q1(), a: m.water_faq_a1() },
          { q: m.water_faq_q2(), a: m.water_faq_a2() },
          { q: m.water_faq_q3(), a: m.water_faq_a3() },
          { q: m.water_faq_q4(), a: m.water_faq_a4() },
        ]}
      />
      <AdPlacement className="mt-10" />
    </SciPage>
  );
}
